import svg from 'lib/svgs.json';
import Button from '../Button';
import { createMarkup } from 'lib/utils/create-markup';
import { mqLargeMin } from 'styled/tools/media-queries';
import styled from 'styled-components';

const ModalWithButtonContainer = styled.div`
  z-index: 1000;
  position: fixed;
  background: rgba(0, 0, 0, 0.55);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
`;

const ModalWithButtonWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  margin: 0;
  max-width: 85%;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  padding: 0px 24px 24px 24px;
  animation: popup 0.5s;

  .close {
    position: absolute;
    right: 0;
    top: 0;
    transform: scale(0.75);
    margin: 16px;
    cursor: pointer;
  }

  @media ${mqLargeMin} {
    max-width: 645px;
  }
`;

const ModalHeader = styled.h1`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 24px 0;
  justify-content: space-between;
  border-bottom: 1px solid var(--outline-neutral);
`;

const ModalSubtext = styled.div`
  margin: 24px 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

interface ModalWithButtonProps {
  isActive: boolean;
  header: React.ReactNode;
  subtext: React.ReactNode;
  buttonText: string;
  onButtonClick: () => void;
  handleCloseModal: () => void;
}

const ModalWithButton = ({
  isActive,
  header,
  subtext,
  buttonText,
  onButtonClick,
  handleCloseModal,
}: ModalWithButtonProps) =>
  // handlers below allow user to click outside the modal to close it
  isActive && (
    <ModalWithButtonContainer onClick={handleCloseModal}>
      <ModalWithButtonWrapper onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          {header}{' '}
          <div
            role='button'
            style={{ transform: 'scale(0.75)' }}
            tabIndex={0}
            aria-labelledby='close-modal-button'
            onClick={handleCloseModal}
            onKeyDown={handleCloseModal}
            dangerouslySetInnerHTML={createMarkup(svg.exit)}
          />
        </ModalHeader>
        <ModalSubtext>{subtext}</ModalSubtext>
        <ButtonWrapper>
          <Button onClick={onButtonClick}>{buttonText}</Button>
        </ButtonWrapper>
      </ModalWithButtonWrapper>
    </ModalWithButtonContainer>
  );

export default ModalWithButton;
